export default __webpack_public_path__ + "static/js-631b340a9d7f19e010e0022e339184f7.svg";